export const EXCEL_DOC = 'excelDoc'
export const PDF = 'pdf'
export const POWERPOINT_DOC = 'powerpoint'
export const WORD_DOC = 'wordDoc'
